export function set({ commit }, item) {
  commit('set', item)
}

export function updateItems(state, payload) {
  state.commit('updateItems', payload)
}
